export default __webpack_public_path__ + "static/media/0xdab35042e63e93cc8556c9bae482e5415b5ac4b1.eaa8d374.png";